import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const letter_endpoints = APIS_ENDPOINTS.letter

export interface IPlansMessagePayload {
  UserId: number
  Files: File[]
}
export const request_sendbyadmin = async ({Files, UserId}: IPlansMessagePayload) => {
  const formData = new FormData()
  if (Files.length !== 0) {
    for (var i = 0; i < Files.length; i++) {
      formData.append('Files', Files[i])
    }
  }
  formData.append('UserId', UserId?.toString())

  return http.post(letter_endpoints.sendbyadmin, formData)
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
  IsMe,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  IsMe: boolean
}) => {
  return http.get(
    letter_endpoints.datatable +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${
        IsMe !== undefined ? `&IsMe=${IsMe}` : ''
      }`
  )
}

export const request_getAllLetterByPersonel = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    letter_endpoints.getall +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_detail = async (id: number) => {
  return http.get(letter_endpoints.detail + `?id=${id}`)
}

export const request_getAllByUser = async ({
  search,
  CurrentPage,
  PageSize,
  UserId,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  UserId: boolean
}) => {
  return http.get(
    letter_endpoints.datatablebyuserid +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${
        UserId !== undefined ? `&UserId=${UserId}` : ''
      }`
  )
}

export const request_acceptletter = async (id: number) => {
  return http.post(letter_endpoints.acceptletter + `?id=${id}`)
}

export const request_getallletternote = async (LetterId: number) => {
  return http.get(letter_endpoints.getallletternote + `?LetterId=${LetterId}`)
}

export const request_addreference = async ({letterId, receiverId, receiverRole, title, text}) => {
  return http.post(letter_endpoints.addreference, {
    letterId,
    receiverId,
    receiverRole,
    title,
    text,
  })
}

export const request_sendreferencetouser = async ({letterId, title, text}) => {
  return http.post(letter_endpoints.sendreferencetouser, {
    letterId,
    title,
    text,
  })
}

export const request_addnote = async ({letterId, title, text, isSendToUser}) => {
  return http.post(letter_endpoints.addnote, {
    letterId,
    title,
    text,
    isSendToUser,
  })
}

export const request_archiveletter = async (id: number) => {
  return http.post(letter_endpoints.archiveletter + `?id=${id}`)
}
